import axios from 'axios';

const rawBaseUrl = import.meta.env.VITE_API_BASE_URL || 'https://api.rimalalkhaleejsyria.com';
export const API_BASE_URL = rawBaseUrl.replace(/\/+$/, '');

function getStoredAuthToken() {
  const raw = localStorage.getItem('authToken');
  if (!raw || raw === 'undefined' || raw === 'null') return null;
  const t = raw.trim();
  return t.length > 0 ? t : null;
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = getStoredAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url ?? '';

    if (status === 401) {
      const isSignIn = url.includes('/api/admin/auth/signin');
      if (!isSignIn) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
